export default {
  background:
    'linear-gradient(to right, #8f817b 0.35%,#7e6f68 14.4%,#685952 36.38%,#61514a 50.32%,#4f413b 71.07%,#312722 100%)',
};
